import { useState } from "react";
import {
    ChevronLeft,
    ChevronRight
} from "lucide-react";

export default function ImageCarousel({

    media = []

}){

    const [index,setIndex] = useState(0);

    if(media.length===0){

        return null;

    }

    function previous(){

        setIndex(

            (prev)=>

                prev===0

                    ? media.length-1

                    : prev-1

        );

    }

    function next(){

        setIndex(

            (prev)=>

                prev===media.length-1

                    ? 0

                    : prev+1

        );

    }

    return(

        <div className="relative mt-6">

            <img

                src={media[index].url}

                alt=""

                className="
                    w-full
                    max-h-[650px]
                    object-cover
                    rounded-3xl
                "

            />

            {

                media[index].caption && (

                    <div
                        className="
                            absolute
                            left-4
                            bottom-4
                            bg-black/60
                            text-white
                            px-4
                            py-2
                            rounded-xl
                            backdrop-blur-md
                        "
                    >

                        {media[index].caption}

                    </div>

                )

            }

            {

                media.length>1 && (

                    <>

                        <button

                            onClick={previous}

                            className="
                                absolute
                                top-1/2
                                left-3
                                -translate-y-1/2
                                w-10
                                h-10
                                rounded-full
                                bg-white/70
                                backdrop-blur
                            "

                        >

                            <ChevronLeft/>

                        </button>

                        <button

                            onClick={next}

                            className="
                                absolute
                                top-1/2
                                right-3
                                -translate-y-1/2
                                w-10
                                h-10
                                rounded-full
                                bg-white/70
                                backdrop-blur
                            "

                        >

                            <ChevronRight/>

                        </button>

                        <div
                            className="
                                absolute
                                bottom-4
                                left-1/2
                                -translate-x-1/2
                                flex
                                gap-2
                            "
                        >

                            {

                                media.map((_,i)=>(

                                    <div

                                        key={i}

                                        className={`
                                            w-2
                                            h-2
                                            rounded-full

                                            ${
                                                i===index

                                                ? "bg-white"

                                                : "bg-white/40"
                                            }
                                        `}

                                    />

                                ))

                            }

                        </div>

                    </>

                )

            }

        </div>

    );

}